import { apiGeneral, queryBuilder } from "services";

export function useValePedagio() {
  const getModoCompra = async (payload: any) => {
    const queryString = queryBuilder(payload);
    const { data } = await apiGeneral.get(`/vale-pedagio/list-buy-mode?${queryString}`);
    return data.map((el: any) => ({
      name: el.nome,
      value: el.codigo,
    }));
  };

  return {
    getModoCompra,
  };
}
